<template>
<div>
    <div>
        <vs-table max-items="10" pagination search :data="devolucionesFacturas">
            <template slot="header">
                <div class="flex">
                    <h5 class="mx-5"><b>Total Precio:</b> {{ totalPrecio | filtrarDecimal  }}</h5>
                    <h5><b>Total Descuento:</b> {{ totalDescuento | filtrarDecimal  }}</h5>
                </div>
            </template>
            <template slot="thead">
                <vs-th sort-key="codigo_devolucion">Documento</vs-th>
                <vs-th sort-key="nombreInstitucion">Destino</vs-th>
                <vs-th sort-key="total_precio">Valor</vs-th>
                <vs-th sort-key="total_descuento">Valor-Descuento</vs-th>
                <!-- <vs-th>Acciones</vs-th> -->
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.codigo_devolucion }}<br>{{ tr.documento }}</vs-td>
                    <vs-td>{{ tr.nombreInstitucion}}</vs-td>
                    <vs-td>{{ tr.total_precio }}</vs-td>
                    <vs-td>{{ tr.total_descuento }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</div>
</template>

    
<script>
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';
export default {
    components: {
        "v-select": vSelect,
        flatPickr,
    },
    data() {
        return {
            arregloaFactura: [],
            usuario: [],
            periodo: '',

        };
    },
    created() {
        let me = this
        me.usuario = JSON.parse(localStorage.getItem("usuario"))
    },
    props: {
        devolucionesFacturas: {
            type: [Object, Array],
            default: {},
        },
    },
    mounted() {
        let me = this;
    },
    computed: {
        totalPrecio() {
            return this.devolucionesFacturas.reduce((acc, tr) => acc + tr.total_precio, 0);
        },
        totalDescuento() {
            return this.devolucionesFacturas.reduce((acc, tr) => acc + tr.total_descuento, 0);
        }
    },
    methods: {

    }
};
</script>
